var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.08,
    height: 92.08,
    viewBox: "0 0 92.08 92.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,46a46,46,0,1,1,46,46A46,46,0,0,1,0,46Z",
    fill: "#0077b5",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.36,38l0-.08V33.18H39.94c.12,3.11,0,33,0,33H50.41V47.74a7.61,7.61,0,0,1,.35-2.68,5.77,5.77,0,0,1,5.38-4c3.8,0,5.32,3,5.32,7.46V66.18H71.94V47.25c0-10.13-5.18-14.85-12.09-14.85a10.32,10.32,0,0,0-9.44,5.47V38ZM28.89,28.66h0A5.58,5.58,0,0,0,34.82,23,5.56,5.56,0,0,0,29,17.27,5.59,5.59,0,0,0,23,23a5.54,5.54,0,0,0,5.78,5.7Zm5.24,37.52h0v-33H23.65v33Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.997a0387b5a9667a7420e11868f1d637.svg";
export { ForwardRef as ReactComponent };